module.exports = __webpack_public_path__ + "img/feature_buy_zh.1a33651e.png";